// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"4019":"96107425","4981":"bbd68e1b","7330":"00c3eb5d","7435":"c5cfd2ca"}[chunkId] + ".css";
};